import React from 'react'
import LeadershipBio from '../leadershipBio'
import { BoardHolder } from './style'

const LeadershipBoard = (props: any) => {
  const { items, microcopy } = props

  const itemList = items[0]
  const bioOrder = itemList && itemList?.bioOrder ? itemList.bioOrder : []

  return (
    <BoardHolder data-cy="BoardHolder">
      {bioOrder.length >= 5 &&
        bioOrder?.map((bio: any, index: number) => {
          const leadershipBioData = { ...bio, microcopy }
          return <LeadershipBio key={`leadershipBio_${index}`} {...leadershipBioData} />
        })}
    </BoardHolder>
  )
}

export default LeadershipBoard
